import $axios from '@/core/api-config'

class TaskService {
  getAll ({ tagIds, bookId }) {
    const tagQuery = tagIds ? `?tags=${tagIds.join(',')}` : ''
    return $axios.get(`/api/tasks/tasks/${bookId}${tagQuery}`)
  }

  create ({ title, subTitle, additionalInfo, isUrgent, taskRowId, projectId, tagIds, bookId, order, dueDate, duplicateToEvent }) {
    return $axios.post(`/api/tasks/task/${bookId}`, { title, subTitle, additionalInfo, isUrgent, taskRowId, projectId, tagIds, order, dueDate, duplicateToEvent })
  }

  complete ({ id, bookId }) {
    return $axios.post(`/api/tasks/complete/${id}/${bookId}`)
  }

  assignMember ({ id, bookId, memberId }) {
    return $axios.post(`/api/tasks/assign/${id}/${bookId}`, { memberId })
  }

  delete ({ id, bookId }) {
    return $axios.delete(`/api/tasks/task/${id}/${bookId}`)
  }

  update ({ id, title, subTitle, additionalInfo, isUrgent, isCompleted, taskRowId, projectId, bookId, dueDate, duplicateToEvent }) {
    return $axios.put(`/api/tasks/task/${id}/${bookId}`, { title, subTitle, additionalInfo, isUrgent, isCompleted, taskRowId, projectId, dueDate, duplicateToEvent })
  }

  order ({ ids, bookId }) {
    return $axios.post(`/api/tasks/order/task/${bookId}`, { ids })
  }

  getTaskTags (bookIds) {
    const booksQuery = bookIds.join(',')
    return $axios.get(`/api/tasks/tags?books=${booksQuery}`)
  }

  toggleTaskTag ({ tagId, taskId, bookId }) {
    return $axios.post(`/api/tasks/tag/${tagId}/${taskId}/${bookId}`)
  }

  updateTaskTag ({ name, id, bookId }) {
    return $axios.put(`/api/tasks/tag/${id}/${bookId}`, { name })
  }

  getRows ({ bookId }) {
    return $axios.get(`/api/tasks/rows/${bookId}`)
  }

  createRow ({ title, color, bookId }) {
    return $axios.post(`/api/tasks/row/${bookId}`, { title, color })
  }

  deleteRow ({ id, bookId }) {
    return $axios.delete(`/api/tasks/row/${id}/${bookId}`)
  }

  updateRow ({ id, title, color, bookId }) {
    return $axios.put(`/api/tasks/row/${id}/${bookId}`, { title, color })
  }

  orderRow ({ ids, bookId }) {
    return $axios.post(`/api/tasks/order/row/${bookId}`, { ids })
  }
}

export const taskService = new TaskService()
